import { JobsState } from '../state/jobsState';
import { AppAction } from '../actions/appAction';
import produce from 'immer';
import { CallDetails } from '../../models/dto/call';

const unloaded: JobsState = {
	details: new Map()
};

export function jobsReducer(state: JobsState | undefined = unloaded, action: AppAction): JobsState {
	switch (action.type) {
		case 'jobs/details-loaded':
			return produce(state, draft => {
				draft.details.set(action.id, action.job);
			});
		case 'call-audio-upload/upload-succeeded':
			return produce(state, draft => {
				const job = draft.details.get(action.jobId);
				if (job) {
					if (job.calls?.some(c => c.id === action.call.id)) {
						job.calls = job.calls?.map(c => {
							if (c.id !== action.call.id)
								return c;

							return { ...c, ...action.call };
						});
					} else {
						if (!job.calls) {
							job.calls = [];
						}
						
						job.calls.push(action.call);
					}
				}
			});
		case 'jobs/completed':
			return produce(state, draft => {
				const job = draft.details.get(action.id);
				if (job) {
					job.complete = true;
				}
			});
		case 'jobs/channel-settings-updated':
			return produce(state, draft => {
				const job = draft.details.get(action.id);
				if (job) {
					job.audioChannel = action.audioChannel;
				}
			});
		case 'jobs/update-call-statuses':
			return produce(state, draft => {
				const job = draft.details.get(action.job.id);
				if (job) {
					const updatedCallsById: Map<number, CallDetails> = new Map((action.job.calls ?? []).map(c => ([c.id, c])));
					job.calls = job.calls?.map(call => updatedCallsById.get(call.id) ?? call);
				}
			});
		default:
			return state;
	}
}